export var IMAGE_FORMATS = {
  webp: 'image/webp',
  jpg: 'image/jpg',
  png: 'image/png',
  svg: 'image/svg+xml',
  '*': 'image'
};